module.exports = __webpack_public_path__ + "static/state-library-exchange-c6ce9df08848a6006fabfe219a03bbbd.jpg";